module.exports = __webpack_public_path__ + "img/icon_picture.d40813d9.svg";